module.exports = "pegasus_template/assets/theme6/twitter-icon-1.png";